import { render, staticRenderFns } from "./HelpComponent.vue?vue&type=template&id=4408aa0a&"
import script from "./HelpComponent.vue?vue&type=script&lang=js&"
export * from "./HelpComponent.vue?vue&type=script&lang=js&"
import style0 from "./HelpComponent.vue?vue&type=style&index=0&id=4408aa0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports